/* eslint-disable linebreak-style */
/** Main project script */

// ensure the main object is defined
if (typeof(so) === 'undefined') {
    var so = {};
}

// main code
so.camden = {
    init: function () {
        $('.no-ss[href]').each(function () {
            if ($(this).attr('href') != '') {
                var link = $(this).attr('href').split('#')[1];
                $(this).attr('href', '#'+link);
            }
        });
    	this.menuInit();
        this.homepageLinkBoxes();
        this.socialButtons();
        this.placesLabelSpan();
        this.iframeFullscreen();
        // this.surveyOverlay();

        $('[data-scroll]').on('click', function (e) {

            var target = $(this).data('scroll');
            var targetel = $(target);
            var scrollto = $(target).offset().top;
            $("html, body").scrollTop(scrollto);
        });
        $('[data-href]').addClass('jslink').on('click', function (e) {
            var target = $(this).data('href');
            window.location.href=target;
        });
        $('.fancybox').fancybox({
            iframe: {'scrolling': 'yes'}
        });

        // get the current text and set the associated option to "selected"
        $('#survey-form select').each(function(){
            $(this).barrating('show', {
                theme: 'bars-movie',
                onSelect: function(value, text) {
                    var parental = $(this).parent();
                    var curText = parental.find('.br-widget .br-current-rating').text();
                    parental.find('select option[value="'+curText+'"]').attr('selected', true);
                }
            });
        });


        // Check if the form exists and has a fieldset
        const form = document.querySelector('#Form_CategoryForm');
        if (form && form.querySelector('fieldset')) {
            const fieldset = form.querySelector('fieldset');
            const newDiv = document.createElement('div');
            newDiv.classList.add('fieldset-wrapper');
            newDiv.innerHTML = fieldset.innerHTML;
            fieldset.parentNode.replaceChild(newDiv, fieldset);
        }
    },
    iframeFullscreen: function () {
        $('iframe[allow="fullscreen"]').each(function () {
            var framesrc, button;
            framesrc = $(this).attr('src');
            button = $('a[href="'+framesrc+'"]').on('click', function(e) {
                var framesrc = $(this).attr('href');
                e.preventDefault();
                var frame = $('iframe[src="'+framesrc+'"]').get(0);
                if (frame.requestFullscreen) {
                    frame.requestFullscreen();
                } else if (frame.mozRequestFullScreen) { /* Firefox */
                    frame.mozRequestFullScreen();
                } else if (frame.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                    frame.webkitRequestFullscreen();
                } else if (frame.msRequestFullscreen) { /* IE/Edge */
                    frame.msRequestFullscreen();
                } else {
                    window.location.href=framesrc;
                }
            });
        });
    },
    placesLabelSpan: function () {
        // wrap filter labels in spans on the places holder
        $('.filtercontrols .checkbox label, .filtercontrols .radio label').each(function () {
            $(this).contents().eq(1).wrap('<span>');
        });
    },
    menuInit: function () {
    	// main menu toggle
        $('.overlay-menu a').on('focus', function () {
            $('.overlay-menu').addClass('active');
        });
        $('.overlay-menu a').on('blur', function () {
            $('.overlay-menu').removeClass('active');
        });
        $('.menu-opener').on('click', function () {
    		$('.overlay-menu').addClass('active');
    	});
    	$('.menu-closer').on('keypress click', function () {
    		$('.overlay-menu').removeClass('active');
    	});
        $( document ).on('keydown', function ( e ) {
            if ( e.keyCode === 27 ) { // ESC
                $('.overlay-menu').removeClass('active');
            }
        });
        $('.collapse').on('show.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                var chevron = $(this).data("chevron");
                $('.'+chevron).removeClass("chevron-down").addClass("chevron-up");
            }
        }).on('hide.bs.collapse', function(e){
            if ($(this).is(e.target)) {
                var chevron = $(this).data("chevron");
                $('.'+chevron).removeClass("chevron-up").addClass("chevron-down");
            }
        });
    },
    homepageLinkBoxes: function () {
        $('.feature-links .feature-link').addClass('pointer').on('click', function () {
            window.location.href = $(this).data('link');
        });
    },
    newsMasonry: function () {
        $('.blog-posts').masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: '.blog-post-item',
            // use element for option
            columnWidth: '.blog-post-item',
            percentPosition: true,
            gutter: 0,
        });
    },
    socialButtons: function () {
        // $('.send-friend-form-toggle').fancybox({
        //     'scrolling'     : 'no',
        //     'titleShow'     : false,
        //     'width'         : 320
        // });
        $('.facebook-link').on('click', function () {
            var link = $(this).attr('href');
            window.open(link, link, "width=500,height=300");
            return false;
        });
        $('.btn-page-print').on('click', function () {
            window.print();
            return false;
        });
    },
    surveyOverlay: function () {
        $('.form_success').hide();
        if (Cookies.get("hide-survey") !== 'true') {
            // grab the cookie
            var cookiePage = Cookies.get("pageload");

            // see if it doesn't exist
            if (cookiePage === 'NaN' ) {
                Cookies.set( 'pageload', '0',  { expires: 7, path: '/' } );  //set default value
                cookiePage = 0;  //set the value to zero
            }
            var cookiePageNum = parseInt(cookiePage,10);  //convert it to a base 10 number

            cookiePageNum++;

            Cookies.set("pageload", cookiePageNum, { expires: 7 , path: '/' }); //save new value

            if (cookiePageNum > 5) { // after 5 pageloads show modal
                var cookieSurvey = Cookies.get("hide-survey");

                if (cookieSurvey !== "true") { //not hidden, so show the box
                    $('#survey').modal(); //
                }

                $('#survey').on('click', '#close', function (e) {
                    e.preventDefault();
                    $('#survey').modal('hide');
                    Cookies.set("pageload", '-5', { expires: 7 , path: '/' }); // give them a rest, but too much of one...
                });

                $('#survey').on('click', '#close-and-save', function (e) {
                    e.preventDefault();
                    $('#survey').modal('hide');
                    Cookies.set('hide-survey', 'true', { expires: 365, path: '/' });
                    Cookies.set('pageload', 'null', { expires: 365, path: '/' });
                });
            }

            $('#survey-form').submit(function(e) {
                var formData = $(this).serialize();

                $.ajax({
                    type     : 'POST',
                    url      : $('#survey-form').attr('action'),
                    data     : formData,
                    dataType : 'json',
                    success  : function (resp) {
                        $('#survey .body, #survey-form, #survey .form_errors').hide();
                        $('#survey .form_success').show();

                        Cookies.set('hide-survey', 'true', { expires: 365, path: '/' });
                    },
                    error : function (resp) {
                        $('#survey .form_errors').html("<p><i>Some errors arrived, check the console</i></p>");
                    }
                });
                e.preventDefault();
            });
        }
    }

};

$(window).on('load', function () {
    so.camden.newsMasonry();
});

$(document).ready(function () {
    so.camden.init();
});
